/**
 * TRIÁSICO — Botón «Añadir» de tr-wine-list (formularios [data-tr-add]).
 * Añade por AJAX y notifica a Horizon con su evento estándar CartLinesUpdateEvent
 * (actualiza la burbuja y el drawer del carrito). Si algo falla, el formulario
 * funciona como un envío normal a /cart/add.
 */
if (!window.trAddToCartReady) {
  window.trAddToCartReady = true;

  let cartEvents = null;
  import('@shopify/events')
    .then((module) => {
      cartEvents = module;
    })
    .catch(() => {});

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-tr-add]')) return;

    const CartLinesUpdateEvent = cartEvents?.CartLinesUpdateEvent;
    if (!CartLinesUpdateEvent?.createPromise) return; // envío normal

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const formData = new FormData(form);
    const variantId = String(formData.get('id'));
    const quantity = Number(formData.get('quantity')) || 1;

    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((element) => element.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    button?.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';

    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Error');

      const cartUrl = window.Theme?.routes?.cart_url || '/cart';
      const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'tr-wine-list',
          sourceId: form.id,
          itemCount: quantity,
          productId: form.dataset.productId,
          sections: data.sections,
          didError: false,
        },
      });

      if (status) status.textContent = 'Añadido al carrito';
    } catch (error) {
      deferred.reject(error);
      if (status) status.textContent = error.message || 'No se ha podido añadir. Inténtalo de nuevo.';
    } finally {
      button?.removeAttribute('aria-busy');
      if (status) setTimeout(() => (status.textContent = ''), 4000);
    }
  });
}
